// extracted by css-extract-rspack-plugin
export default {"cls1":"UserTaggingPingBodyStyles-cls1_mMW","cls2":"UserTaggingPingBodyStyles-cls2_ReN UserTaggingPingBodyStyles-cls1_mMW"};